import styled from '@emotion/styled';
import { Flex } from '@landsbankinn/ui-kit';

// TODO: swap to UIKIT component when WEB-42351 is ready!
export const FadeIn = styled(Flex)`
  animation: fadeIn 1000ms ease-in-out forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
